import React from 'react';
import Modal from 'react-responsive-modal';

import './News.scss';

export default class News extends React.Component {
  state = {
    open: false,
    activeNew: this.props.langs.news[0]
  };

  onOpenModal = (itemId) => {
    this.setState({
      open: true,
      activeNew: this.props.langs.news[itemId]
    });
  };

  onCloseModal = () => {
    this.setState({open: false});
  };

  renderNews = () => {
    return this.props.langs.news.map((item) =>
      <div className="news_item_col" key={item.id}>
        <div onClick={this.onOpenModal.bind(this, item.id - 1)} className="news_item">
          <div className="news_item_img"><img src={item.img} alt={this.props.langs.imgAlt.imgAlt}/></div>
          <div className="news_item_content">
            <div className="news_item_title">{item.title}</div>
            <div className="news_item_time">{item.createdAt}</div>
            <div className="news_item_desc">{item.subTitle}</div>
            <div className="news_item_btn">Číst Více</div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const {open, activeNew} = this.state;

    return (
      <section className="news">
        <div className="container">
          <h2 className="line text-center">Novinky</h2>

          <div className="news_item_row">
            {this.renderNews()}
          </div>

          <div className="text-center">
            <button className="btn">Načíst starší</button>
          </div>
        </div>

        <Modal
          open={open}
          onClose={this.onCloseModal}
          classNames={{
            'modal': 'news_modal',
            'closeButton': 'homeSales_modal_close',
          }}
        >
          <div className="news_modal_header">
            <img src={activeNew.img} alt={this.props.langs.imgAlt.imgAlt}/>
            <div className="news_modal_header_content">
              <div className="news_modal_title">{activeNew.title}</div>
            </div>
          </div>
          <div className="news_modal_content">
            <div className="news_modal_time">Přidáno dne: {activeNew.createdAt}</div>
            <div dangerouslySetInnerHTML={{__html: activeNew.desc}}/>
            {activeNew.imgs &&
            <div className="news_modal_imgs">
              {activeNew.imgs.map((item, index) => {
                return (
                  <div className="news_modal_imgs_item">
                    <img src={item} key={index} alt={this.props.langs.imgAlt.imgAlt}/>
                  </div>
                )
              })}
            </div>
            }
          </div>
        </Modal>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/News/News/News.js